import { Theme } from "@material-ui/core"
import makeStyles from "@material-ui/core/styles/makeStyles"
import CloseIcon from "@material-ui/icons/Close"
import React from "react"
import cal from "clsx"
import { Tag } from "Types/app"
import { ArticleType } from "Types/article"
import { Author } from "Types/author"
import { useMouseGesture } from "Hooks/basic"

interface ComponentProps {
    tag: Tag,
    onDelete: (tag: Tag) => void,
    color?: string,
    value: string,
    canDelete: boolean,
}

const useStyles = makeStyles((theme: Theme) => ({
    tagItem: {
        backgroundColor: "#00bcd4",
        padding: `0px 32px 0px 16px`,
        borderRadius: "38px",
        height: 38,
        lineHeight: "40px",
        color: "white",
        margin: `10px ${theme.spacing(1)}px`,
        cursor: "pointer",
        boxSizing: "border-box",
        fontSize: 16,
        position: "relative",
        transition: "all .3s ease",
    },
    icon: {
        fontWeight: "bold",
        position: "absolute",
        right: 4,
        top: 9,
        opacity: 0,
    },
    tagItemExpand: {
        // paddingRight: 32,
        // transform: "scale(1.1)",
        transition: "all .3s ease",
    },
    iconShow: {
        opacity: 1,
    },
}))
const TagItem = (props: ComponentProps) => {
    const { tag, onDelete, canDelete, value} = props
    const { name } = tag
    const { color_code: backgroundColor = "", hidden } = tag as ArticleType
    const classes = useStyles()
    const { show, handleMouseEnter, handleMouseLeave} = useMouseGesture()
    const typeName = (tag as ArticleType).type_name
    let userName = ""
    if ((tag as Author).user_public) {
        userName = (tag as Author).user_public.nickname || ""
    }
    const showClose = show && canDelete
    return (
        <div
            className={cal(
                classes.tagItem,
                showClose && classes.tagItemExpand,
            )}
            style={{
                background: backgroundColor,
                display: hidden ? "none" : "block",
            }}
            onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}
        >
            {name}
            &nbsp;
            { value === "author" && userName && <em>{`(${userName})`}</em> }
            {showClose && (
                <CloseIcon fontSize="small" className={cal(
                    classes.icon,
                    show && classes.iconShow,
                )} onClick={() => onDelete(tag)}/>
            )}
        </div>
    )
}

export default TagItem
